import {
    Autocomplete,
    Box,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    createFilterOptions,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    FormControlLabel,
    Checkbox,
    FormGroup,
    Stack,
    Button
  } from "@mui/material";
import { PersonPinOutlined,
    DragIndicatorTwoTone, 
  } from "@mui/icons-material";
import { useForm } from "../hooks";
import React, { useContext, useEffect } from "react";
import { AuthContext, PreventiviNewContext, NationsContext } from "../context";
import { isRequired } from "../hooks/useForm";
import * as R from "ramda";
import {
  Assicurazione,
  MerceADR,
  Contrassegno,
  DettaglioMisureMerce,
  Mittente
} from "../components/PreventiviFormComponent/"
import { useNavigate } from "react-router-dom";
import { titlePage, getFlagPath } from "../utilities";
import { green } from '@mui/material/colors';
import { QuestionAnswerTwoTone } from '@mui/icons-material'
import { DatePicker } from '@mui/x-date-pickers';
//import { TimePicker } from "@mui/x-date-pickers";
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { DateRangeRounded } from '@mui/icons-material';
import moment from 'moment';

const filterOptions = createFilterOptions({
    matchFrom: "any",
    limit: 100,
  });

const normalizeNationIso = (value, nationList = []) => {
  if (!value) return value;

  const normalizedValue = String(value).trim().toUpperCase();
  const canonicalValue = normalizedValue === "I" ? "IT" : normalizedValue;
  const byIso = nationList.find((item) => item?.nazioneiso?.toUpperCase() === canonicalValue);

  if (byIso) return byIso.nazioneiso;

  const byDescription = nationList.find(
    (item) => item?.descrizione?.toLowerCase() === canonicalValue.toLowerCase()
  );

  return byDescription?.nazioneiso || value;
};

const getNationLabel = (value, nationList = [], fallback = "Italia") => {
  if (!value) return fallback;

  const canonicalValue = String(value).trim().toUpperCase() === "I" ? "IT" : String(value).trim().toUpperCase();
  const byIso = nationList.find((item) => item?.nazioneiso?.toUpperCase() === canonicalValue);
  if (byIso) return byIso.descrizione || fallback;

  const byDescription = nationList.find(
    (item) => item?.descrizione?.toLowerCase() === String(value).trim().toLowerCase()
  );

  return byDescription?.descrizione || fallback;
};

const PreventiviNew = () => {

    //MENU NAZIONI
    const {
        state: { nations, provincesFrom, provincesTo, loading },
        getNationsOnly, getNationsOnlyTo, getProvincesListsByNationFrom, getProvincesListsByNationTo, svuotaCacheNations
      } = useContext(NationsContext);


   
    //valid check
    const { addValidCheck } = useContext(AuthContext);

    //INDICATORI MITTENTE E DESTINATARIO
    const [checkedIndicatoriMittente, setCheckedIndicatoriMittente] = React.useState([]);
    const [checkedIndicatoriDestinatario, setCheckedIndicatoriDestinatario] = React.useState([]);
    
    const [loadingPreventivi, setLoadingPreventivi] = React.useState(false);

    const [ localitaMittAll , setLocalitaMittAll] = React.useState('')
    


    //import da PreventiviNewContext
    const { 
        state:{
            configPreventivo,
            indicatoriMitt,
            indicatoriDest,
            form
            },
        getIndicatoriMitt,
        getIndicatoriDest,
        postNuovoPreventivo,
        getConfigModePreventivo,
        resetPreventivo

     } = useContext(PreventiviNewContext);

     const navigate = useNavigate()

    //TODO cambiare nomi variabili
    const validations = [
        ({ MittLocalita }) =>
          isRequired(MittLocalita) || { MittLocalita: "*Località mittente obbligatoria" },
        ({ MittProvincia }) =>
          isRequired(MittProvincia) || { MittProvincia: "*Provincia mittente obbligatoria" },
        ({ MittNazione }) =>
          isRequired(MittNazione) || { MittNazione: "*Nazione mittente obbligatoria" },
        ({ MittCap }) => isRequired(MittCap) || { MittCap: "*Cap mittente obbligatorio" },
        ({ DestLocalita }) =>
          isRequired(DestLocalita) || { DestLocalita: "*Localita obbligatoria" },
        ({ DestProvincia }) =>
          isRequired(DestProvincia) || { DestProvincia: "*Localita obbligatoria" },
        ({ DestCap }) =>
          isRequired(DestCap) || { DestCap: "*Localita obbligatoria" },
        ({ DestNazione }) =>
          isRequired(DestNazione) || { DestNazione: "*Localita obbligatoria" },
    ];
 

    //FORM
    const {
        values: nuovoPreventivoForm,
        changeHandler,
        touched,
        errors,
        isValid,
        setValues
      } = useForm(
        {
          //mittente
          MittLocalita: "",
          MittProvincia: "",
          MittCap: "",
          MittNazione: "IT",
          MittNazioneCompleta : "Italia",
          IndicatoriMitt : [],

          //destinatario
          DestLocalita: "",
          DestProvincia: "",
          DestCap: "",
          DestNazione: "IT",
          IndicatoriDest : [],
          DestNazioneCompleta : "Italia",

          ServizioPerWeb:" ",
          ordmerce:[],
          //contrassegno
          TipoIncasso: "",
          Contrassegno: "",
          ContrassegnoValuta: "EUR",

          //adr
          ordadr:[],

          //assicurazione
          StimaValMerce:"",
          StimaValMerceValuta:"EUR",
          totRows : {},
          Epal: 0,
          DataRichiesta: "",
          OraRichiesta : "",

        },
        validations
      );
      if (nuovoPreventivoForm.MittNazione === undefined){
        setValues({
        ...nuovoPreventivoForm,
         MittNazione : "IT"
        
        })
      }

      if (nuovoPreventivoForm.DestNazione === undefined){
        setValues({
        ...nuovoPreventivoForm,
         DestNazione : "IT",
        
        })
      }

      
      const resetPreventivoForm = () => {       
        window.location.reload()
      }


      //INDICATORI MERCE
      const changeIndicatoriMittenteChecked = (isChecked, code) => {
        if (isChecked) {
          setCheckedIndicatoriMittente([
            ...checkedIndicatoriMittente.filter((res) => res !== code),
            code,
          ]);
          setValues({
            ...nuovoPreventivoForm,
            IndicatoriMitt: [
              ...checkedIndicatoriMittente.filter((res) => res !== code),
              code,
            ],
          });
        } else {
          setCheckedIndicatoriMittente([
            ...checkedIndicatoriMittente.filter((res) => res !== code),
          ]);
          setValues({
            ...nuovoPreventivoForm,
            IndicatoriMitt: [...checkedIndicatoriMittente.filter((res) => res !== code)],
          });
        }
      };


      const changeIndicatoriDestinatarioChecked = (isChecked, code) => {
        if (isChecked) {
          setCheckedIndicatoriDestinatario([
            ...checkedIndicatoriDestinatario.filter((res) => res !== code),
            code,
          ]);
          setValues({
            ...nuovoPreventivoForm,
            IndicatoriDest : [
              ...checkedIndicatoriDestinatario.filter((res) => res !== code),
              code,
            ],
          });
        } else {
          setCheckedIndicatoriDestinatario([
            ...checkedIndicatoriDestinatario.filter((res) => res !== code),
          ]);
          setValues({
            ...nuovoPreventivoForm,
            IndicatoriDest: [...checkedIndicatoriDestinatario.filter((res) => res !== code)],
          });
        }
      };

      const localitaTimerTo = React.useRef(null);
      useEffect(() => () => clearTimeout(localitaTimerTo.current), []);

      // Dopo almeno 3 lettere e 500 ms senza altra digitazione, cerca le località.
      const cercaLocalitaDest = (testo) => {
        clearTimeout(localitaTimerTo.current);
        const t = (testo || "").trim();
        // se il testo contiene " - " è un'opzione già scelta, non si cerca
        if (t.length < 3 || t.includes(" - ")) return;
        localitaTimerTo.current = setTimeout(() => {
          getProvincesListsByNationTo(nuovoPreventivoForm.DestNazione, t);
        }, 500);
      };

      const changeDestValue = (newValue) => {
        cercaLocalitaDest(newValue);
        if(newValue){
          changeHandler("DestLocalita", newValue);
          nuovoPreventivoForm.DestCap = newValue.split(" - ")[0];
          nuovoPreventivoForm.DestProvincia = newValue.split(" - ")[2]
            ? newValue.split(" - ")[2]
            : "";
        }else{
          changeHandler("DestLocalita", newValue);
        }
      };


      useEffect(() => {
        addValidCheck(isValid);
      }, [isValid]);

  
      useEffect(() => {


        //TODO gestire traduzioni titolo pagina
        titlePage("","Preventivi")
        getConfigModePreventivo();
        getIndicatoriMitt();
        getIndicatoriDest();
        //dett. merce 
   
        const savedForm =
          form && typeof form === "object" && Object.keys(form).length > 0
            ? form
            : null;

        let luogoRitiro = JSON.parse(localStorage.getItem("luogoRitiro") || "null");

        const hasSavedDraft = Boolean(
          savedForm &&
            (savedForm.MittNazione ||
              savedForm.DestNazione ||
              savedForm.MittLocalita ||
              savedForm.DestLocalita ||
              savedForm.MittRagSoc ||
              savedForm.DestRagSoc ||
              savedForm.ordmerce?.length ||
              savedForm.ordadr?.length)
        );

        if (hasSavedDraft) {
          const mittNazioneIso = normalizeNationIso(savedForm?.MittNazione, nations);
          const destNazioneIso = normalizeNationIso(savedForm?.DestNazione, nations);

          setValues({
            ...nuovoPreventivoForm,
            ...savedForm,
            MittLocalita: savedForm.MittLocalita ?? "",
            MittProvincia: savedForm.MittProvincia ?? "",
            MittCap: savedForm.MittCap ?? "",
            MittNazione: mittNazioneIso ?? savedForm?.MittNazione ?? "IT",
            MittNazioneCompleta:
              savedForm?.MittNazioneCompleta ||
              getNationLabel(mittNazioneIso, nations, "Italia"),
            DestLocalita: savedForm.DestLocalita ?? "",
            DestProvincia: savedForm.DestProvincia ?? "",
            DestCap: savedForm.DestCap ?? "",
            DestNazione: destNazioneIso ?? savedForm?.DestNazione ?? "IT",
            DestNazioneCompleta:
              savedForm?.DestNazioneCompleta ||
              getNationLabel(destNazioneIso, nations, "Italia"),
            IndicatoriMitt: savedForm.IndicatoriMitt ?? [],
            IndicatoriDest: savedForm.IndicatoriDest ?? [],
            ServizioPerWeb: savedForm.ServizioPerWeb ?? " ",
            ordmerce: savedForm.ordmerce ?? [],
            TipoIncasso: savedForm.TipoIncasso ?? "",
            Contrassegno: savedForm.Contrassegno ?? "",
            ContrassegnoValuta: savedForm.ContrassegnoValuta ?? "EUR",
            ordadr: savedForm.ordadr ?? [],
            StimaValMerce: savedForm.StimaValMerce ?? "",
            StimaValMerceValuta: savedForm.StimaValMerceValuta ?? "EUR",
            totRows: savedForm.totRows ?? {},
            Epal: savedForm.Epal ?? 0,
            DataRichiesta: "",
            OraRichiesta: "",
          });

       
          setCheckedIndicatoriMittente(savedForm.IndicatoriMitt ?? []);
          setCheckedIndicatoriDestinatario(savedForm.IndicatoriDest ?? []);
        }
        //10/02/2024 Greg: Su richiesta di Monia: autocompletamento da luogoRitiro delle info del mittente
        else if (
          luogoRitiro?.Localita     && luogoRitiro.Localita !== ''
          && luogoRitiro?.Provincia && luogoRitiro.Provincia !== ''
          && luogoRitiro?.Cap       && luogoRitiro.Cap !== ''  
          && luogoRitiro?.Nazione   && luogoRitiro.Nazione !== ''         
        ){
          setValues({
            ...nuovoPreventivoForm,
            MittLocalita        : luogoRitiro.Localita,
            MittProvincia       : luogoRitiro.Provincia,
            MittCap             : luogoRitiro.Cap,
            // MittNazione         : luogoRitiro.Nazione
          });
        }
        
        return function cleanup() {
          svuotaCacheNations();
        };

      }, []);


      // useEffect(() => {
      // }, [nuovoPreventivoForm]);

      localStorage.setItem("nations", JSON.stringify(nations))
    
      useEffect(() => {


        getNationsOnly();
        svuotaCacheNations();

        nations.map((params, key) => {
            if (params.nazioneiso === nuovoPreventivoForm.MittNazione){
              nuovoPreventivoForm.MittNazioneCompleta = params.descrizione;
             
            };
        });

      }, [nuovoPreventivoForm.MittNazione]);

      useEffect(() => {


        getNationsOnlyTo();
        if (nuovoPreventivoForm.DestNazione !== "IT") {
            nuovoPreventivoForm.DestCap = "";
            nuovoPreventivoForm.DestLocalita = "";
            nuovoPreventivoForm.DestProvincia = "";
        }

        nations.map((params, key) => {
            if (params.nazioneiso === nuovoPreventivoForm.DestNazione){
              nuovoPreventivoForm.DestNazioneCompleta = params.descrizione;             
            };
        });

      }, [nuovoPreventivoForm.DestNazione]);

    

  return (
    <div>
      <Stack direction={"row-reverse"} spacing={2} mt={2}>
        <Box sx={{position:'relative'}}>
          <Button
            color="success"
            size={"medium"}
            variant={"contained"}
            disabled={loadingPreventivi}
            onClick={() => postNuovoPreventivo(nuovoPreventivoForm/*, handleClose*/, navigate, setLoadingPreventivi)}
            >
              calcola preventivo
          </Button>
          {loadingPreventivi && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px',
              }}
            />
          )}
        </Box>
        
        <Box sx={{position:'relative'}}>
          <Button
            color="warning"
            size={"medium"}
            variant={"contained"}
            disabled={loadingPreventivi}
            onClick={() => resetPreventivoForm()}
            >
              SVUOTA CAMPI
          </Button>
          {loadingPreventivi && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: '-12px',
                marginLeft: '-12px',
              }}
            />
          )}
        </Box>
      </Stack>

      <Mittente
            setMainForm={setValues}
            mainForm={nuovoPreventivoForm}
            riferimentoCaption={false}
            riferimentoVisible={false}
            luogoRitiroVisible={true}
            readOnly={false}
            indicatoriConfig={false}
            formAutomatico={false}
            indirizzoCodificatoDefault={false}
            accessoriSubtitle={""}

      />              

        <Card elevation={0} sx={{ background: (theme) => theme.palette.success.light + "25" }}>
          <CardHeader 
            title={"Destinatario"}
            subheaderTypographyProps={{
              fontWeight: "bold",
            }}
            titleTypographyProps={{
              fontWeight: "bold",
              fontSize: 18,
            }}
            subheader={"Dati del Destinatario"}
            avatar={<PersonPinOutlined />}

          />
          <CardContent>
            <Grid item container spacing={1}>
          
              <Grid item xs={12} md={6} lg={6} mt={2}>
                <FormControl fullWidth>
                  <InputLabel id="select-from-nations">Nazione</InputLabel>
                  <Select
                    fullWidth
                    disabled={loading}
                    size="small"
                    labelId="select-from-nations"
                    id="select-from-nations"
                    value={nuovoPreventivoForm.DestNazione || ""}
                    label="Nazione"
                    onChange={(e) => changeHandler("DestNazione", e.target.value)}
                  >
                    <MenuItem value={-1}>SELEZIONA NAZIONE</MenuItem>
                    {nations?.map((params, key) => (
                      <MenuItem key={key} value={params.nazioneiso}>
                        <Box sx={{ "& > img": { mr: 2, flexShrink: 0 } }}>
                          
                          <img
                            loading="lazy"
                            width="20"
                            src={
                              params.nazioneiso?.toLowerCase() !== ""
                                ? `${getFlagPath(window.location.href, params.nazioneiso)}`
                                : ""
                            }
                            srcSet={
                              params.nazioneiso?.toLowerCase() !== ""
                                ? `${getFlagPath(window.location.href, params.nazioneiso)} 2x`
                                : ""
                            }
                            alt=""
                          />
                          {params.descrizione}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {nuovoPreventivoForm.DestNazione === -1 ||
              nuovoPreventivoForm.DestNazione === "IT" ? (
                <Grid item xs={12} md={6} lg={6}>
                  <Autocomplete
                    fullWidth
                    value={nuovoPreventivoForm.DestLocalita || ""}
                    inputValue={nuovoPreventivoForm.DestLocalita || ""}
                    size="small"
                    isOptionEqualToValue={(option, value) => option.provincia === value.provincia || option.localita === value.localita}
                    filterOptions={filterOptions}
                    id="select-from-provinces"
                    //groupBy={(option) => option.split(" - ")[1][0]}
                    options={provincesTo?.map((item) => {
                      return `${item.cap} - ${item.localita}${
                        item.provincia ? ` - ${item.provincia}` : ""
                      }`;
                    })}
                    loading={loading}
                    onInputChange={(e, newValue) => {
                      changeDestValue(newValue);
                    }}
                    onChange={(e, newValue) => {
                      changeDestValue(newValue);
                    }}
                    disabled={loading}
                    //getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cap - Località - Provincia "
                        sx={{ marginTop: 2 }}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              {loading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : (
                                ""
                              )}
                              {params.InputProps.startAdornment}
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>
              ) : (
                <Grid item xs={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Località"
                    size="small"
                    value={nuovoPreventivoForm.DestLocalita || ""}
                    onChange={(e) => changeHandler("DestLocalita", e.target.value)}
                    disabled={loading}
                    sx={{ marginTop: 2 }}
                  />
                </Grid>
              )}

              {nuovoPreventivoForm.DestNazione === -1 ||
              nuovoPreventivoForm.DestNazione === "IT" ? (
                <></>
              ) : (
                <Grid item xs={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Cap"
                    size="small"
                    value={nuovoPreventivoForm.DestCap || ""}
                    onChange={(e) => changeHandler("DestCap", e.target.value)}
                    disabled={loading}
                    sx={{ marginTop: 2 }}
                  />
                </Grid>
              )}

                {/* -----------------------------------------------------------------------------------------------------------------OCCHIO AL NOME MITTENTE.. DESTINATARIO?? */}

                {configPreventivo.destinatarioindicatori?.visible  && indicatoriDest?.length > 0 ?(
                    <Grid item xs={12} md={12} lg={12}>
                    <Card elevation={0} sx={{ background: (theme) => theme.palette.warning.main + "20" }}>
                        <CardHeader
                        subheader={
                          (configPreventivo?.destinatarioindicatori?.label) && (configPreventivo.destinatarioindicatori.label !== "")?
                            (configPreventivo.destinatarioindicatori.label):("Accessori destinatario")
                        } 
                        subheaderTypographyProps={{
                            fontWeight: "bold",
                        }}
                        avatar={<DragIndicatorTwoTone color={"primary"} />}
                        />
                    </Card>
                    </Grid>
                ) : (
                    <></>
                )}
                {/* -----------------------------------------------------------------------------------------------------------------OCCHIO AL NOME MITTENTE.. DESTINATARIO?? */}
                {configPreventivo.destinatarioindicatori?.visible && indicatoriDest?.length > 0 ?(
                    indicatoriDest.map((data, index) => {
                    return (
                        <Grid item xs={12} md={2} lg={2} key={index}>
                        <FormGroup>
                            <FormControlLabel
                            control={
                                <Checkbox
                                  //disabled={readOnly}
                                  checked={checkedIndicatoriDestinatario?.includes(data.codice)}
                                  onChange={(e) => 
                                      changeIndicatoriDestinatarioChecked(
                                        e.target.checked,
                                        data.codice,
                                      )
                                      // changeIndicatoriDestinatarioCheckedDescrizione(
                                      //   e.target.checked,
                                      //   data.descrizione,
                                      // )
                                    
                                  }
                                />
                            }
                            label={data.descrizione}
                            />
                        </FormGroup>
                        </Grid>
                    );
                    })
                ) : (
                    <></>
                )}
            </Grid>
          </CardContent>
        </Card>  
        <Grid container spacing={0} mt={2} mb={3}>
          <Grid item xs={12} md={12} lg={12}>
            {configPreventivo.datarichiesta?.visible? (
              <Card elevation={0} sx={{ background: (theme) => theme.palette.warning.main + "20" }}>
                <CardHeader
                  title={"Data tassativa di consegna"}
                  //subheader={subtitle !== "" ? (subtitle):("")}
                  subheaderTypographyProps={{
                    fontWeight: "bold",
                  }}
                  titleTypographyProps={{
                    fontWeight: "bold",
                    fontSize:18
                  }}
                  avatar={<DateRangeRounded />}
                />
                <CardContent>
                  <Grid item container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Stack spacing={2} direction={"row"}>
                          <DatePicker
                            label={"Data"}
                            value={nuovoPreventivoForm.DataRichiesta || null}
                            onChange={(e, newValue) => {
                              changeHandler("DataRichiesta", moment(e).format("YYYY-MM-DD"));
                            }}
                            renderInput={(params) => <TextField {...params} size="small" />}
                          />
                        </Stack>
                      </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ):(<></>)}


            {configPreventivo.orarichiesta?.visible? (
              <Card elevation={0} sx={{ background: (theme) => theme.palette.warning.main + "20" }}>
                <CardHeader
                  title={"Orario di consegna"}
                  //subheader={subtitle !== "" ? (subtitle):("")}
                  subheaderTypographyProps={{
                    fontWeight: "bold",
                  }}
                  titleTypographyProps={{
                    fontWeight: "bold",
                    fontSize:18
                  }}
                  avatar={<DateRangeRounded />}
                />
                <CardContent>
                  <Grid item container spacing={1}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Stack spacing={2} direction={"row"}>
                          <DesktopTimePicker
                            label={"Ora"}
                            value={nuovoPreventivoForm.OraRichiesta || null}
                            onChange={(e, newValue) => {
                              changeHandler("OraRichiesta", moment(e).format("hh:mm"));
                            }}
                            disableOpenPicker={true}
                            renderInput={(params) => <TextField {...params} size="small" />}
                          />
                        </Stack>
                      </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ):(<></>)}
  
        {configPreventivo?.dettagliomisuremerce?.visible ? (
          <DettaglioMisureMerce setPrevMainForm={setValues} prevMainForm={nuovoPreventivoForm} />
          ) : (
          <></>
        )}

<Card elevation={0} sx={{ background: (theme) => theme.palette.warning.main + "20" }}>
      <CardHeader
        title={"Richiesta di epal a rendere"}
        //subheader={subtitle !== "" ? (subtitle):("")}
        subheaderTypographyProps={{
          fontWeight: "bold",
        }}
        titleTypographyProps={{
          fontWeight: "bold",
          fontSize:18
        }}
        avatar={<QuestionAnswerTwoTone />}
      />
      <CardContent>
        <Grid item container spacing={1}>
          <Grid item xs={12} md={12} lg={12}>
            <TextField
              margin="normal"
              fullWidth
              size="small"
              label="Epal"
              type="number"
              autoComplete="off"
              onWheel={(e) => e.target.blur()}
              InputProps={{
                inputProps: { min: 0 }
              }}
              value={nuovoPreventivoForm.Epal || ""}
              onChange={(e) => {changeHandler("Epal", e.target.value)}}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>

        
        {configPreventivo?.contrassegno?.visible ?  (
          <></>
          ):(
          <Contrassegno setPrevMainForm={setValues} prevMainForm={nuovoPreventivoForm} />
        ) }

        {configPreventivo?.merceadr?.visible ? (
          <MerceADR setPrevMainForm={setValues} prevMainForm={nuovoPreventivoForm} />
          ) : (
          <></>
        )}
 
        {configPreventivo?.assicurazione?.visible ? (
          <Assicurazione setPrevMainForm={setValues} prevMainForm={nuovoPreventivoForm} />
          ) : (
          <></>
        )}
      </Grid>
    </Grid>
    <Stack direction={"row-reverse"} spacing={2} mt={2}>

      <Box sx={{position:'relative'}}>
        <Button
          color="success"
          size={"medium"}
          variant={"contained"}
          disabled={loadingPreventivi}
          onClick={() => postNuovoPreventivo(nuovoPreventivoForm/*, handleClose*/, navigate, setLoadingPreventivi)}
         >
            calcola preventivo
        </Button>
        {loadingPreventivi && (
          <CircularProgress
            size={24}
            sx={{
              color: green[500],
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}
      </Box>
        

      {/* <Button
        color="warning"
        size={"medium"}
        variant={"contained"}
        onClick={() => resetPreventivoForm()}
      >
        SVUOTA CAMPI
      </Button> */}
    </Stack>
    </div>
  )
}

export default PreventiviNew